export default "__VITE_ASSET__w24JOOVA__"